import { injectIntl } from "react-intl";
import { Card, CardContent, CardHeader, Drawer, IconButton, Stack, Typography } from "@mui/material";
import { IosShareOutlined as IosShareOutlinedIcon, AddBoxOutlined as AddBoxOutlinedIcon } from "@mui/icons-material";
import {
  INSTALLATION_DRAWER_SUBHEADER,
  INSTALLATION_DRAWER_INFO,
  INSTALLATION_DRAWER_SHARE_INSTRUCTIONS,
  INSTALLATION_DRAWER_SHARE_LABEL,
  INSTALLATION_DRAWER_ADD_TO_HOME_INSTRUCTIONS,
  INSTALLATION_DRAWER_ADD_TO_DOCK_INSTRUCTIONS,
  INSTALLATION_DRAWER_ADD_TO_HOME_LABEL,
  INSTALLATION_DRAWER_ADD_TO_DOCK_LABEL,
} from "../../modules/language";
import { DockIcon, LogoApplicativoIcon } from "../../styles/images";
import { getMessageString } from "../../utility";
import { Icona } from "./";
import { MAC, detectDevice, detectBrowser } from "./GuidaInstallazione";

export const InstallationDrawer = injectIntl(({ intl, open, onClose }) => {
  const userAgent = navigator.userAgent;

  return (
    <Drawer anchor="bottom" open={open} className="iosInstallationDrawer">
      <Card>
        <CardHeader
          avatar={<LogoApplicativoIcon />}
          action={
            <IconButton aria-label="Chiudi drawer installazione iOS" onClick={onClose}>
              <Icona tipologia="chiudi_t" />
            </IconButton>
          }
          title="PS Tracker"
          subheader={getMessageString(intl, INSTALLATION_DRAWER_SUBHEADER)}
        />
        <CardContent>
          <Stack>
            <Typography>{getMessageString(intl, INSTALLATION_DRAWER_INFO, { browser: detectBrowser(), device: detectDevice() })}</Typography>
            <Stack direction="row">
              <IosShareOutlinedIcon />
              <Typography>
                {getMessageString(intl, INSTALLATION_DRAWER_SHARE_INSTRUCTIONS)}
                <strong>{getMessageString(intl, INSTALLATION_DRAWER_SHARE_LABEL)}</strong>
              </Typography>
            </Stack>
            <Stack direction="row">
              {userAgent.includes(MAC) ? (
                <Stack className="dockIcon">
                  <DockIcon />
                </Stack>
              ) : (
                <AddBoxOutlinedIcon />
              )}
              <Typography>
                {getMessageString(
                  intl,
                  userAgent.includes(MAC) ? INSTALLATION_DRAWER_ADD_TO_DOCK_INSTRUCTIONS : INSTALLATION_DRAWER_ADD_TO_HOME_INSTRUCTIONS
                )}
                <strong>
                  {getMessageString(intl, userAgent.includes(MAC) ? INSTALLATION_DRAWER_ADD_TO_DOCK_LABEL : INSTALLATION_DRAWER_ADD_TO_HOME_LABEL)}
                </strong>
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Drawer>
  );
});
